import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { articles, seasonalGuides, getCurrentSeason, getArticleSeason } from '../../pages/BlogPage';

const BlogPreviewSection = () => {
  const currentSeason = getCurrentSeason();
  const seasonConfig = seasonalGuides[currentSeason];
  const SeasonIcon = seasonConfig.icon;

  const displayArticles = articles.filter(a => getArticleSeason(a) === currentSeason).slice(0, 4);

  return (
    <section className="py-12 lg:py-16 bg-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Seasonal Guide Header */}
        <div className="text-center mb-10">
          <div className={`inline-flex items-center gap-2 bg-gradient-to-r ${seasonConfig.colors.gradient} text-white px-4 py-2 rounded-full text-sm font-bold mb-4`}>
            <SeasonIcon size={16} />
            {seasonConfig.title}
          </div>
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-slate-900 mt-4 mb-6">
            {seasonConfig.headline}
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            {seasonConfig.description}
          </p>
        </div>

        {/* Seasonal Guide Articles Grid - 4 columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {displayArticles.map((article) => {
            const ArticleIcon = SeasonIcon;
            const articleGradient = seasonConfig.colors.gradient;
            const articleLabel = `${seasonConfig.name} Guide`;
            
            return (
              <Link key={article.id} to={`/blog/${article.slug}`} className="group" data-testid={`seasonal-guide-${article.id}`}>
                <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 h-full flex flex-col relative">
                  <div className="absolute top-3 right-3 z-10">
                    <span className={`inline-flex items-center gap-1 bg-gradient-to-r ${articleGradient} text-white px-2 py-1 rounded-full text-xs font-bold shadow-lg`}>
                      <ArticleIcon size={10} />
                      {articleLabel}
                    </span>
                  </div>
                  <div className="aspect-video overflow-hidden">
                    <img 
                      src={article.image} 
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5 flex flex-col flex-grow">
                    <div className="flex items-center gap-2 text-sm text-slate-500 mb-2">
                      <Clock size={14} />
                      <span>{article.readTime}</span>
                    </div>
                    <h3 className={`font-heading font-bold text-lg text-slate-900 mb-2 ${seasonConfig.colors.groupHover} transition-colors line-clamp-2`}>
                      {article.title}
                    </h3>
                    <p className="text-slate-600 text-sm line-clamp-2 mb-3 flex-grow">{article.excerpt}</p>
                    <span className={`inline-flex items-center gap-2 ${seasonConfig.colors.accent} font-semibold text-sm`}>
                      Read Guide <ArrowRight size={16} />
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {/* View All Button */}
        <div className="text-center mt-10">
          <Link to="/blog" className="btn-secondary inline-flex items-center gap-2" data-testid="view-all-blog-btn">
            View All Expert Tips <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogPreviewSection;
